import React from 'react';
import { FaWhatsapp } from 'react-icons/fa'; 
import './whatsapp.css'; 

const WhatsAppButton = () => {
  const phoneNumber = '+94776937010'; 
  const message = 'Hello, I need assistance with...'; 
  const encodedMessage = encodeURIComponent(message);

  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

  return (
    <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="whatsapp-button">
      <FaWhatsapp size={40} /> 
    </a>
  );
};

export default WhatsAppButton;


